export const environment = {
    production: false,
    appName: 'Oleh Rumyk',
    googleAnalyticsId: '',
    dd_app_id: '9945c88c-c6cc-4cec-8ed7-9b06d1d62064',
    dd_client_token: 'pub5f92f81fc9adfcae13ce0d9e8f1ecb85',
    dd_env: 'local'
};
